module.exports = __webpack_public_path__ + "img/back2.dad391c2.png";